import { render, staticRenderFns } from "./WeekNews.vue?vue&type=template&id=572ecde0&"
import script from "./WeekNews.vue?vue&type=script&lang=ts&"
export * from "./WeekNews.vue?vue&type=script&lang=ts&"
import style0 from "./WeekNews.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports